import React, { Component, Suspense, lazy } from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from '../../store';
import Authenticated from '../OnlyAuthenticated';
import { ToastContainer } from 'react-toastify';
import { Helmet } from 'react-helmet';
import './App.scss';
import 'react-toastify/dist/ReactToastify.css';
import { hasCredentials } from '../../commons/js/utils/hasCredentials';
import loadingIcon from '../../commons/images/Spinner-1s-200px.gif';
import '../../commons/scss/_print.scss';
import BKIDocument from '../BKIDocument'; 
import SSOCallback from '../Login/SSOCallback';
const Design = lazy(() => import('../Design'))
const Login = lazy(() => import('../../containers/Login'))
const ResetPassword = lazy(() => import('../../containers/ResetPassword'))
const WelcomeUser = lazy(() => import('../../containers/WelcomeUser'))
const PdfPreview = lazy(() => import('../PdfPreviewPopup'))
const Layout = lazy(() => import('../../containers/Layout'))
class App extends Component {
  constructor(props) {
    super(props)

    const isLoggedIn = store.getState().session.isLoggedIn;


    if (isLoggedIn) {
      if (hasCredentials()) {

      } else {
        store.dispatch({
          type: 'LOGOUT',
        })
        // this.props.logout();
      }
    } else {
      if (hasCredentials()) {
        store.dispatch({
          type: "SET_LOGGED_IN",
          payload: {
            role: JSON.parse(localStorage.getItem("roleId")),
            value: true,
          }
        })
        // this.props.setLoggedIn(localStorage.getItem("role"));
      } else {

      }
    }
  }

  // hasCredentials() {
  //   let token = localStorage.getItem("token");
  //   let role = localStorage.getItem("role");
  //   let userId = localStorage.getItem("userId");

  //   return !!(token && role && userId);
  // }

  render() {
    return (
      <Provider store={store}>
        <BrowserRouter>
          <div className="App">
            <Helmet>
              <title>BKI</title>
              {/* <NewRelic licenseKey="46f6bca68be7da7333e544c34104bab59410f1d0" applicationID="188695403" /> */}
            </Helmet>
            <Suspense fallback={
              <div className="loading-package loading-image-erm">
                <img src={loadingIcon} alt="Loading" />
              </div>}>
              <Switch>
                <Route path="/design" component={Design} />
                <Route path="/sso_success/callback" component={Authenticated(SSOCallback, null, true)}/>
                <Route path="/login" component={Authenticated(Login, null, true)} />
                <Route path='/equipment_labels' component={BKIDocument}/>
                <Route path='/duct_insp' component={BKIDocument}/>
                <Route path='/life_safety' component={BKIDocument}/>
                <Route exact path="/complete-profile/:id/accept" component={WelcomeUser} />
                <Route exact path="/reset-password/:resetToken" component={ResetPassword} />
                <Route exact path="/pdf" component={PdfPreview} />
                <Route component={Layout} />
                <Route exact path="/" render={(props) => {
                  return <Redirect to="/login" />
                }} />
              </Switch>
            </Suspense>
            <ToastContainer autoClose={4000} draggable={false} />
          </div>
        </BrowserRouter>
      </Provider>
    );
  }
}

export default App;
